
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "MenusSchedule",
  props: {
    label: {
      type: String,
      required: true
    },
    response: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    black: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const iconClass = computed(() => ({
      [props.icon]: true,
      black: props.black
    }));

    return { iconClass };
  }
});
